import PropTypes from "prop-types";

import ImmutablePropTypes from "react-immutable-proptypes";
import ImmutablePureComponent from "react-immutable-pure-component";

import { Avatar } from "flavours/glitch/components/avatar";
import Permalink from "flavours/glitch/components/permalink";
 
import initialState from "flavours/glitch/initial_state";

export default class NavigationBar extends ImmutablePureComponent {

  static propTypes = {
    account: ImmutablePropTypes.map.isRequired,
    onLogout: PropTypes.func.isRequired,
  };

  render () {
    return (
      <div className='navigation-bar'>
        <Permalink className='avatar' href={this.props.account.get("url")} to={`/@${this.props.account.get("acct")}`}>
          <span style={{ display: "none" }}>{this.props.account.get("acct")}</span>
          <Avatar account={this.props.account} size={48} />
        </Permalink>

        <div className='navigation-bar__profile'>
          <div>{this.props.account.get("display_name")}</div>
          <Permalink className='acct' href={this.props.account.get("url")} to={`/@${this.props.account.get("acct")}`}>
            <strong>@{this.props.account.get("acct")}</strong>
            <span>@{initialState.meta.domain}</span>
          </Permalink>
        </div>
      </div>
    );
  }

}
